import React from 'react'

type Props = {}

export default function LoginPage({}: Props) {
  return (
    <div>LoginPage</div>
  )
}